import React, { Fragment } from 'react';
import { useLocation, useMatch } from 'react-router';
import { Layout } from 'antd';
import { HeaderLayout } from '../../components/Header';
import { SiderMenu } from '../../components/LeftMenu';
import NotFoundComponent from '../../components/NotFound';

const PageNotFound = () => {
    const location = useLocation();
    const match = useMatch(location.pathname);

    return (
        <Fragment>
            <SiderMenu menus={[]} />
            <Layout>
                <HeaderLayout />
                <Layout.Content className='layout-content'>
                    <NotFoundComponent match={match} />
                </Layout.Content>
            </Layout>
        </Fragment>
    );
};

export default PageNotFound;
